Namespace 'Common.Sessions'

class Common.Sessions.NewSessionView extends Backbone.View
  template: JST['backbone/templates/common/sessions/new_session']
  id: 'new-session'

  initialize: ({session, filtersFactory, chartListItemCollectionViewFactory}) ->
    @sessionFiltersView = new Common.Dashboard.Filters.FiltersView
      session: session
      filtersFactory: filtersFactory
    @resizeButtonView = new Common.ResizeButton({onClick: @_onResizeButtonClick})
    @sessionChartsView = new Common.Sessions.SessionChartsView({session, chartListItemCollectionViewFactory})
    @

  render: =>
    @$el.html(@template())
    @renderSessionFilters()
    @renderSessionCharts()
    @

  renderSessionFilters: ->
    @$('#session-filters-container').empty()
      .append(@sessionFiltersView.render().el)
      .append(@resizeButtonView.render().el)

  renderSessionCharts: ->
    @$('#session-charts-container').empty().append(@sessionChartsView.render().el)

  _onResizeButtonClick: =>
    @toggleFilters()
    @sessionChartsView.onFiltersMenuToggle()

  toggleFilters: =>
    @$('#session-filters-container').toggleClass('filters-closed')

  shouldRerender: =>
    @$el.children().length == 0
